// extracted by mini-css-extract-plugin
export default {"button":"AnchorButton_button__npoS5 btn","link":"AnchorButton_link__RFyvY AnchorButton_button__npoS5 btn"};